import { Collapse } from '@material-ui/core';

import utilsProvider from '../../../providers/utils.provider';
import AdjustmentPiecePicker from './adjustment.piece.picker.component';

const PICKER_ANIMATION_MS = 200;

const rowClassName = (item, isChecked) => {
    const selection = isChecked ? 'border-[#376fd0] bg-[#f2f6fd]' : 'border-[#e5e5e5] bg-white';
    const enabled = item.available ? 'hover:border-[#376fd0] cursor-pointer' : 'opacity-60 cursor-not-allowed';

    return ['w-full text-left px-4 py-3 rounded-xl border transition', selection, enabled].join(' ');
}

const boxClassName = (isChecked) => [
    'w-[19px] h-[19px] rounded-md border shrink-0 grid place-items-center text-white text-xs font-bold',
    isChecked ? 'bg-[#376fd0] border-[#376fd0]' : 'bg-white border-[#c9c9c9]'
].join(' ');

const CustomerCharged = ({ amount }) => (
    <span><i className="not-italic font-semibold text-[#1f8f5f]">CLIENTE</i> paga + {utilsProvider.formatNumberCurrency(amount)} do pacote</span>
);

const CustomerRefunded = ({ amount }) => (
    <span><i className="not-italic font-semibold text-[#1f8f5f]">CLIENTE</i> recebe {utilsProvider.formatNumberCurrency(Math.abs(amount))} de volta no pacote</span>
);

const CustomerUntouched = () => (
    <span><i className="not-italic font-semibold text-gray-400">CLIENTE</i> <span className="text-gray-400">não é cobrado</span></span>
);

const CustomerSide = ({ amount }) => {
    if (amount > 0) return <CustomerCharged amount={amount} />;

    return amount < 0 ? <CustomerRefunded amount={amount} /> : <CustomerUntouched />;
}

const FaciliterSide = ({ amount, replacesTotal }) => {
    if (replacesTotal)
        return <span><i className="not-italic font-semibold text-[#b8651b]">FACILITER</i> passa a receber o valor cheio de volta</span>;

    if (!amount)
        return <span><i className="not-italic font-semibold text-gray-400">FACILITER</i> <span className="text-gray-400">não muda</span></span>;

    return amount > 0
        ? <span><i className="not-italic font-semibold text-[#b8651b]">FACILITER</i> recebe + {utilsProvider.formatNumberCurrency(amount)}</span>
        : <span><i className="not-italic font-semibold text-[#b8651b]">FACILITER</i> perde {utilsProvider.formatNumberCurrency(Math.abs(amount))}</span>;
}

const BothSides = ({ item, entry }) => (
    <span className="flex flex-wrap gap-x-5 gap-y-1 text-xs text-[#1d1d1f] mt-1">
        <CustomerSide amount={entry ? entry.preview.customerDelta : item.customerAmount} />
        <FaciliterSide
            amount={entry ? entry.preview.faciliterDelta : item.faciliterAmount}
            replacesTotal={Boolean(entry && entry.preview.replacesTotal)}
        />
    </span>
);

const OpenInvoiceNotice = ({ month }) => (
    <span className="mt-1 text-xs text-[#b8651b]">
        A fatura deste serviço já fechou — o crédito entra na fatura de {month}.
    </span>
);

const ItemBody = ({ item, entry, isChecked, onSwitch }) => (
    <div
        role="checkbox"
        tabIndex={item.available ? 0 : -1}
        aria-checked={isChecked}
        aria-disabled={!item.available}
        onClick={() => item.available && onSwitch()}
        onKeyDown={event => item.available && [' ', 'Enter'].includes(event.key) && (event.preventDefault(), onSwitch())}
        className="flex items-start gap-3"
    >
        <span className={boxClassName(isChecked)} aria-hidden="true">{isChecked ? '✓' : ''}</span>

        <div className="flex flex-col gap-1 grow">
            <span className="text-sm font-medium text-[#1d1d1f]">{item.label}</span>
            <span className="text-xs text-gray-500">{item.available ? item.description : item.unavailableReason}</span>
            {item.available && <BothSides item={item} entry={entry} />}
            {item.available && item.openInvoiceMonth && <OpenInvoiceNotice month={item.openInvoiceMonth} />}
        </div>
    </div>
);

export default function AdjustmentItemRow({ item, entry, option, pieceOptions, onToggle, onRemove, onChangePiece }) {

    const isChecked = Boolean(entry);
    const showsPicker = isChecked && Boolean(item.requiresServiceChoice);
    const switchItem = () => isChecked ? onRemove(entry.entryId) : onToggle(item);

    return (
        <div className={rowClassName(item, isChecked)}>
            <div className="flex items-start justify-between gap-3">
                <ItemBody item={item} entry={entry} isChecked={isChecked} onSwitch={switchItem} />

                {isChecked && (
                    <button type="button" onClick={() => onRemove(entry.entryId)} className="shrink-0 text-xs text-gray-500 underline">
                        Remover
                    </button>
                )}
            </div>

            <Collapse in={showsPicker} timeout={PICKER_ANIMATION_MS} unmountOnExit>
                <AdjustmentPiecePicker
                    pieceOptions={pieceOptions}
                    entry={entry}
                    option={option}
                    onChange={choice => onChangePiece(entry, choice)}
                />
            </Collapse>
        </div>
    );
}
